module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sbox"
  }, [_c('h2', {
    staticClass: "subchapter",
    attrs: {
      "id": "s001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#s1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Layered Ham and Cheese Croissant Casserole")])])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/5-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("Yield: 7 large croissant sandwiches | Prep Time: 20 minutes plus overnight set | Cook Time: 1 hour")]), _vm._v(" "), _c('p', {
    staticClass: "recipenote"
  }, [_vm._v("Nothing says brunch, and morning comfort, like a ham and cheese croissant. This casserole can be made the night before, which makes things even easier in the morning. Serve straight out of the casserole dish as individual sandwiches, or cut up and place on a platter. I like to shingle the croissants so they’re easy to grab out of the dish individually. Either way, find yourself some flaky croissants and kick off your weekend!")])]), _vm._v(" "), _c('p', {
    staticClass: "serves"
  }, [_c('strong', [_vm._v("INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "indger1"
  }, [_vm._v("7 croissants")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("2 tablespoons Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("14 thin slices deli ham")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("7 slices Swiss cheese")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("10 large eggs")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1½ cups whole milk")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("½ teaspoon freshly ground black pepper")]), _vm._v(" "), _c('h2', {
    staticClass: "Directions"
  }, [_c('strong', [_vm._v("DIRECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("1. Lightly coat a 9 × 13-inch baking dish with cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("2. Slice the croissants, spread each one with mustard, and fill them with the ham and cheese. Shingle the croissant sandwiches into the casserole dish.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("3. Beat the eggs in a medium bowl, add the milk, salt, and pepper, and mix well. Pour over the sandwiches and cover the dish with foil. Weight the top with a plate or cookie sheet to submerge the sandwiches in the egg mixture and refrigerate for at least 4 hours or overnight.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("4. Preheat the oven to 350°F. Bake, covered with the foil, for 30 minutes. Remove the foil and bake for an additional 30 minutes. Serve.")]), _vm._v(" "), _c('h2', {
    staticClass: "head"
  }, [_c('strong', [_vm._v("VARIATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Spice the sandwiches up with pepper jack cheese or add a touch of sweetness with honey Dijon mustard.")]), _vm._v(" "), _c('h2', {
    staticClass: "headn"
  }, [_c('strong', [_vm._v("NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("It’s all about the croissants! If you can find some at a local bakery, the superior quality and freshness will certainly shine through.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c702278","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/s001.vue
// module id = 84
// module chunks = 0